import React from 'react'
import './index.less'
import cdn from 'src/helper/cdn'

import lang from '../lang'

export default class extends React.Component {
  state = {
    ruleStatus: false
  }

  constructor(props) {
    super(props)
    let { language } = this.props
  }

  // shouldComponentUpdate(nextProps) {
  //   console.log('shouldComponentUpdate')
  //   // return false
  // }

  componentDidMount() {
    // console.log('componentDidMount')
  }

  componentWillReceiveProps(e) {
    // console.log('componentWillReceiveProps')
  }

  hideRule = async (status) => {
    this.setState({
      ruleStatus: status
    })
  }

  render() {
    let { language, list, lang } = this.props
    return (
      <div>
        {this.state.ruleStatus && <div className="loading" onClick={this.hideRule.bind(this, false)}></div>}
        {this.state.ruleStatus && (
          <div className={`chenRule ${language == 'ar' && 'arlang'}`} onClick={this.hideRule.bind(this, false)}>
            <div className="ptop">{lang.rule}</div>
            <div className="content">
              <div className="text">
                <div className="ye" dangerouslySetInnerHTML={{ __html: lang.register || '' }}></div>

              </div>
            </div>
            <div className="pbottom"></div>
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/ruby-activity/Rule/index.js